import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  CERTIFICATE_ADDED_SUCCESS_LABEL,
  DATA_DELETED_SUCCESS_LABEL,
  ERROR_LABEL,
  ERROR_MESSAGE_LABEL,
} from "../../constants/Dictionary";
import CmSheetCertificateOfCertificationsService from "../../services/api/cmSheet/CmSheetCertificateOfCertfications.service";
import { UpdateCmSheetCertificateOfCertificationsRequest } from "../../types/api/collaborators.type";
import { useNotification } from "../notification.hook";
import { CM_SHEET_CERTIFICATIONS_QUERY_KEY } from "./certifications.hook";

export const useUpdateCmSheetCertificationCertificate = (
  cmSheetId: number,
  certificationId: number,
) => {
  const { notification } = useNotification();
  const queryClient = useQueryClient();

  const { mutateAsync: updateCertificationCertificate, isPending: isUpdating } =
    useMutation({
      mutationFn: (body: UpdateCmSheetCertificateOfCertificationsRequest) =>
        CmSheetCertificateOfCertificationsService.update(
          cmSheetId,
          certificationId,
          body,
        ),
      onSuccess: async () => {
        await queryClient.invalidateQueries({
          queryKey: [CM_SHEET_CERTIFICATIONS_QUERY_KEY],
        });
        notification.success(
          CERTIFICATE_ADDED_SUCCESS_LABEL,
          undefined,
          "toast",
        );
      },
      onError: (error) => {
        console.error(error);
        notification.error(ERROR_LABEL, ERROR_MESSAGE_LABEL);
      },
    });

  return { updateCertificationCertificate, isUpdating };
};

export const useDeleteCmSheetCertificationCertificate = (cmSheetId: number) => {
  const { notification } = useNotification();
  const queryClient = useQueryClient();

  const { mutateAsync: deleteCertificationCertificate, isPending: isDeleting } =
    useMutation({
      mutationFn: (certificationId: number) =>
        CmSheetCertificateOfCertificationsService.delete(
          cmSheetId,
          certificationId,
        ),
      onSuccess: async () => {
        await queryClient.invalidateQueries({
          queryKey: [CM_SHEET_CERTIFICATIONS_QUERY_KEY],
        });
        notification.success(DATA_DELETED_SUCCESS_LABEL, undefined, "toast");
      },
      onError: (error) => {
        console.error(error);
        notification.error(ERROR_LABEL, ERROR_MESSAGE_LABEL);
      },
    });

  return { deleteCertificationCertificate, isDeleting };
};
